import { ShopsApiClient } from '@fourthwall/services/dist/ShopsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useCreateAdditionalShopMutation = createMutationHook(
  ShopsApiClient.createAdditionalShop,
  {
    mutationKey: ['createAdditionalShop'],
  },
)
